export const FETCH_DATA = "FETCH_DATA";
export const FETCH_MENU = "FETCH_MENU";
export const FETCH_METADATA = "FETCH_METADATA";
export const UPLOAD_MEDIA = "UPLOAD_MEDIA";
export const UPDATE_DATA = "UPDATE_DATA";
export const CLEAR_UPDATE_MESSAGE = "CLEAR_UPDATE_MESSAGE";
export const CLEAR_REVIEW_MESSAGE = "CLEAR_REVIEW_MESSAGE";
export const AUDIT_REVIEW_DATA = "AUDIT_REVIEW_DATA";
export const DOWNLOAD_TEMPLATE = "DOWNLOAD_TEMPLATE";
export const CLEAR_DOWNLOAD_TEMPLATE = "CLEAR_DOWNLOAD_TEMPLATE";
export const SUMMARY_DATA = "SUMMARY_DATA";
export const USER_LIST = "USER_LIST";
export const APPROVE_MULTI_BATCH = "APPROVE_MULTI_BATCH";
export const DOWNLOAD_EXCEL_TEMPLATE = "DOWNLOAD_EXCEL_TEMPLATE";
